import React from "react";

import { SnackBarContext } from "../contexts/snackbar";

export const useSnackBar = () => {
    return React.useContext(SnackBarContext);
}